import * as React from 'react';

const Cart = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17.226" height="16.001" viewBox="0 0 17.226 16.001">
    <g id="shopping-cart" transform="translate(-1.5 -3)">
      <g id="Group_1992" data-name="Group 1992" transform="translate(1.5 3)">
        <path
          id="Path_2195"
          data-name="Path 2195"
          fill="currentColor"
          fillRule="evenodd"
        />
        <path
          d="M13.6,30.2A1.6,1.6,0,1,0,12,28.6,1.6,1.6,0,0,0,13.6,30.2Z"
          data-name="Path 2196"
          fill="currentColor"
          id="Path_2196"
          data-name="Path 2196"
          d="M13.6,30.2A1.6,1.6,0,1,0,12,28.6,1.6,1.6,0,0,0,13.6,30.2Z"
          transform="translate(-6.4 -14.199)"
          fill="#f8faf2"
        />
        <path
          d="M25.7,28.6A1.6,1.6,0,1,1,24.1,27,1.6,1.6,0,0,1,25.7,28.6Z"
          data-name="Path 2197"
          fill="currentColor"
          id="Path_2197"
          data-name="Path 2197"
          d="M25.7,28.6A1.6,1.6,0,1,1,24.1,27,1.6,1.6,0,0,1,25.7,28.6Z"
          transform="translate(-11.299 -14.199)"
          fill="#f8faf2"
        />
      </g>
    </g>
  </svg>
);

export default Cart;
